import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Input, Icons, Button, Tooltip } from '@/js/libs/ui/src/V2';
import { DEFAULT_STATIC_SEARCH_DEBOUNCE } from '../constants';
import { SearchWrapper } from '../styled';
import {} from '../types';
export const Search = memo(function Search({ mode, onDebouncedChange, onClear, disabled, isInlineMode, toggleInlineMode, hideInlineToggle, disableInlineToggle, translations, hasLoadOptions = false, }) {
    const { colors } = useTheme();
    const [localValue, setLocalValue] = useState('');
    const isSelectionMode = mode === 'selection';
    const isInputDisabled = disabled || (isSelectionMode && isInlineMode);
    // Debounced callback for static options only
    const debouncedChange = useDebouncedCallback((value) => {
        if (!hasLoadOptions) {
            onDebouncedChange(value);
        }
    }, DEFAULT_STATIC_SEARCH_DEBOUNCE);
    const handleChange = useCallbackRef((event) => {
        const { value } = event.target;
        setLocalValue(value);
        if (hasLoadOptions) {
            // For async options, call immediately (parent handles debouncing)
            onDebouncedChange(value);
        }
        else {
            // For static options, use local debouncing
            debouncedChange(value);
        }
    });
    const handleClear = useCallbackRef(() => {
        setLocalValue('');
        onClear();
    });
    const icon = useMemo(() => localValue ? (_jsx(Icons.Clear, { onClick: handleClear, filled: true, size: 16, color: colors.grey100_1, dataTestId: `${mode}-search-clear` })) : (_jsx(Icons.Search, { size: 16, color: colors.grey100_1 })), [colors, handleClear, localValue, mode]);
    return (_jsxs(SearchWrapper, { children: [_jsx(Input, { value: localValue, onChange: handleChange, placeholder: translations.search, icon: icon, isActionIcon: !!localValue, disabled: isInputDisabled, dataTestId: `${mode}-search` }), isSelectionMode && toggleInlineMode && !hideInlineToggle && (_jsx(Tooltip, { tooltip: translations.toggleSelection, placement: 'top', children: _jsx(Button, { onClick: toggleInlineMode, disabled: disableInlineToggle, ghost: true, iconOnly: true, dataTestId: 'inline-toggle', children: _jsx(Icons.ToggleList, { active: isInlineMode }) }) }))] }));
});
